import dayjs from "dayjs"

import { INCOGNITO_MASK } from "../../../../Components/Private"
import { isIncognitoActive } from "../../../../Utils/incognito"
import { formatCurrency } from "../../../../Utils/utils"

export const getChartOptions = ({ theme, setTooltipImperative, dataType }) => ({
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      // left: 10,
    }
  },
  interaction: {
    // mode: 'index',
    intersect: false
  },
  stacked: false,
  hover: {
    // mode: 'nearest',
    // intersect: false,
    cursor: "pointer" // добавьте это свойство
  },
  //make cursor pointer
  onHover: function (event, chartElement) {
    if (chartElement.length) {
      event.native.target.style.cursor = "pointer"
    } else {
      event.native.target.style.cursor = "default"
    }
  },
  plugins: {
    title: {
      display: false
    },
    tooltip: {
      // Disable the on-canvas tooltip
      enabled: false,

      external: function (context) {
        const tooltipModel = context.tooltip
        if (tooltipModel.opacity === 0) {
          setTooltipImperative({ visible: false })
          return
        }

        const position = context.chart.canvas.getBoundingClientRect()

        const payload = {
          visible: true,
          x: position.left + window.pageXOffset + tooltipModel.caretX,
          y: position.top + window.pageYOffset + tooltipModel.caretY,
          value: context.tooltip.dataPoints?.[0]?.raw ?? null,
          date: dayjs(context.tooltip.dataPoints[0].label).format("MMM DD, YYYY")
        }
        setTooltipImperative(payload)
      }
    },
    legend: {
      display: false
    }
  },
  scales: {
    x: {
      type: "time",
      time: {
        unit: "day", // 'week' or 'day' or 'hour'
        //minUnit: 'hour',
        displayFormats: {
          hour: "hh a",
          // hour: 'MMM dd, hh a',
          day: "MMM DD",
          week: "MMM DD",
          month: "MMM DD",
          quarter: "MMM DD",
          year: "MMM"
        },
        tooltipFormat: "MMM DD, YYYY"
      },
      grid: {
        drawOnChartArea: false,
        tickColor: "transparent"
      },
      border: {
        display: false
      },
      ticks: {
        font: {
          size: 12,
          weight: 400
        }
      }
    },
    y: {
      type: "linear",
      //grace: 100,
      // display: showFilteredTrafficScale,
      display: true,
      position: "left",
      beginAtZero: true,
      grid: {
        color: theme === "dark" ? "rgba(255, 255, 255, 0.12)" : "#E1E1E2",
        tickColor: "transparent"
      },
      border: {
        display: false,
        dash: [4, 4]
      },
      ticks: {
        maxTicksLimit: 6,
        font: {
          size: 12
        },
        callback: function (value) {
          if (dataType === "volume") {
            if (isIncognitoActive()) return INCOGNITO_MASK
            if (value >= 10) return formatCurrency(value, true)
            return formatCurrency(value)
          }
          if (value >= 1000) {
            return value / 1000 + "k"
          } else {
            return value
          }
        }
      }
    }
  },
  datasets: {
    line: {
      pointRadius: 0, // disable for all `'line'` datasets
      lineTension: 0.25
    }
  }
})
